import React, { useState } from "react";
import Box from "@mui/material/Box";
import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';


const style = {
    overflow: "auto",
    width: '100%',
    height: 200,
    color: 'inherit',
    backgroundColor: 'inherit',
    border: '1px solid grey',
    resize: 'none',
    outline: 'none',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    boxSizing: 'border-box'
}

const buttonStyle = {
    position: 'absolute',
    top: 8,
    right: 8,
    transform: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    color: 'orange',
    borderRadius: '4px',
    padding: '4px',
    minWidth: 'auto',
    width: '32px',
    height: '32px'
}

const TextSubTitle = ({ text, compact = false, matchVideo = false }) => {
    const [feedback, setFeedback] = useState('Copy to clipboard')

    const feedBackTimeout = () => {
        setTimeout(() => {
            setFeedback('Copy to clipboard')
        }, 1000)
    }
    const onCopy = (text) => {
        setFeedback('Copied!')

        navigator.clipboard.writeText(text).then(function () {
            // ('Async: Copying to clipboard was successful!');
        },
            function (err) {
                // console.error('Async: Could not copy text: ', err);
            });
        feedBackTimeout()
    }

    const containerStyle = matchVideo ? {
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    } : compact ? {
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    } : {
        position: 'relative',
        width: 340
    };

    const textareaStyle = matchVideo ? {
        ...style,
        width: '100%',
        height: '100%',
        fontSize: '11px',
        minHeight: '170px'
    } : compact ? {
        ...style,
        height: 120,
        fontSize: '12px',
    } : style;

    return (
        <Box sx={containerStyle}>
            <textarea style={textareaStyle} value={text} readOnly />
            <Tooltip title={feedback} placement="top">
                <IconButton style={buttonStyle}
                    onClick={() => {
                        onCopy(text)
                    }}
                >
                    <ContentCopyIcon style={{ fontSize: 15 }} />
                </IconButton>
            </Tooltip>
        </Box>
    )
}


export default TextSubTitle;
